import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import "url-search-params-polyfill";
import { routes } from './routes'
import * as CustApi from "@/api/cust"
import { pageTrack } from "../api/cust";
import moment from 'moment';

Vue.use(Router);

// 白名单
const whiteList = [
  "/login",
  "/login/wechatAuthLogin",
  "/home",
  "/agreement/reg",
  "/agreement/shop",
  "/licence",
  "/newbie",
  "/gesture",
  "/preview",
  "/agreement/privacy",
  "/channelLogin",
  "/paysuccess",
  "/rechargesuccess",
  "/applet-pay-course",
  "/applet-agreement",
  "/agreement/userPrivacy",
  "/applet-agreement-investor",
  "/callback",
  "/description",
  "/pointsasmoney",
  "/rebatepoints",
  "/news",
  "/news-detail",
  "/notice",
  "/personalCenter-loginpwd1",
  "/personalCenter-loginpwd2",
  "/personalCenter-loginpwd3",
  "/personalCenter-loginpwd4",
  "/search_inviter",
  "/mpayweb/payinit",
  "/mpayweb/payresult",
  "/downloadapp",
  "/productDetails",
  "/mall-template",
];

let enterTime = Date.now();
const timerCount = 3 * 60 * 1000
let pageTrackTimer = null;

const page_track = (to, from) => {
  let currentTime = Date.now();
  if (store.state.userInfo && store.state.userInfo.custAccount.custId) {
    if (parseInt((currentTime - enterTime) / 1000) > 0) {
      let params = {
        custId: store.state.userInfo.custAccount.custId,
        pageName: from.meta.title,
        enterTime: moment(enterTime).format("YYYY-MM-DD HH:mm:ss"),
        stayTime: parseInt((currentTime - enterTime) / 1000),
      }
      pageTrack(params).then((data) => {
        enterTime = Date.now();
      }).catch((e) => {
        console.log('页面追踪失败：' + e.msg || e.message);
      })
    }
  }
};
const clearPageTrackTimer = () => {
  if (pageTrackTimer) {
    clearTimeout(pageTrackTimer);
    pageTrackTimer = null;
  }
};

const setPageTrackTimer = (to) => {
  clearPageTrackTimer();

  pageTrackTimer = setTimeout(() => {
    let currentTime = Date.now();
    if (store.state.userInfo && store.state.userInfo.custAccount.custId) {
      let params = {
        custId: store.state.userInfo.custAccount.custId,
        pageName: to.meta.title || document.title,
        enterTime: moment(enterTime).format("YYYY-MM-DD HH:mm:ss"),
        stayTime: parseInt((currentTime - enterTime) / 1000),
      };
      pageTrack(params).then((data) => {
        enterTime = Date.now();
        setPageTrackTimer(to);
      }).catch((e) => {
        console.log('页面追踪失败：' + e.msg || e.message);
      });
    }
  }, timerCount);
};

const router = new Router({
  mode: 'hash',//去掉url中的#，避免ios/android加载页面异常
  routes,
  //vue实现返回上一页面，页面停留在原来位置，不刷新
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach(async (to, from, next) => {
  console.log('router from == %O, router to == %O', from, to);
  // ios‘撤销键入’弹框提示处理
  let input = document.getElementsByTagName('input');
  for (const item of input) {
    item.blur();
  }
  /*
  if (store.state.user.token) {
    let currentDateTime = new Date().getTime()
    if (localStorage.getItem("lastTrackTimeKey")) {
      let lastTime = localStorage.getItem("lastTrackTimeKey")
      if (((currentDateTime - lastTime) / 1000) >= 18000) { // 5h
        store.commit("logout")
        localStorage.removeItem("lastTrackTimeKey")
        localStorage.setItem("lastTrackTimeKey", currentDateTime)
        location.href = "/#/login";
        next();
        return;
      }
    }
    localStorage.removeItem("lastTrackTimeKey")
    localStorage.setItem("lastTrackTimeKey", currentDateTime) // ms
  }
  */
  if (to.name === 'integralMall' && to.query && to.query.referrerType) { // 保存从积分商城进入类型
    localStorage.setItem("MallEnterKey", to.query.referrerType)
  }
  if (to.meta.title && store.state.user.token) {
    page_track(to, from);
    setPageTrackTimer(to);
  } else {
    clearPageTrackTimer();
  }
  //回调和渠道登录不做验证，可以直接跳转
  if (to.name === "callback" || to.name === "channelLogin" || to.name === "wechatAuthLogin" || to.name === "downloadapp" || to.name === "productDetails") {
    next();
    return;
  }

  //静默登陆，如果有token就直接登录
  if (to.meta.silenceAuth == true && !store.state.user.token) {
    //判断是否带有token,如果有token只需要把token放到state中
    //然后查询用户信息
    let token = to.query.token
    if (token) {
      store.commit("setToken", token)
    } else {
      console.log("token不存在")
    }
  }

  //记住我/自动登录
  if (store.state.user.token) {
    if (!store.state.user.userInfo) {
      store.dispatch("silenceAuth")//静默登录
        .then(() => {
          enterProductCustom(to, next);
        })
        .catch(async (ex) => {
          console.error("silence login failed,to-route=%O", to)
          console.error(ex)
          if (whiteList.indexOf(to.path) !== -1 || to.meta.auth === false) {
            //有在白名单中的路径或meta.auth 为 false 不需要登录
            next();
          } else {
            store.commit("logout");
            let query = {
              redirect: to.fullPath
            };
            if (to.query.invite) {
              query.invite = to.query.invite;
            } else if (to.query.productId && to.query.referrerCod && to.query.referrerType) {// 定制化产品分享链接进入
              query.productId = to.query.productId
              query.referrerCod = to.query.referrerCod
              query.referrerType = to.query.referrerType
            } else if (to.query.sectionId && to.query.referrerCod && to.query.referrerType) {// 专享产品列表分享链接进入
              query.sectionId = to.query.sectionId
              query.referrerCod = to.query.referrerCod
              query.referrerType = to.query.referrerType
            }
            await router.push({
              name: "login",
              query: query
            });
          }
        });
    } else {
      enterProductCustom(to, next);
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1 || to.meta.auth === false) {
      //有在白名单中的路径或meta.auth 为 false 不需要登录
      next();
    } else {
      store.commit("logout");
      let query = {
        redirect: to.fullPath
      };
      if (to.query.invite) {
        query.invite = to.query.invite;
      } else if (to.query.productId && to.query.referrerCod && to.query.referrerType) {// 定制化产品分享链接进入
        query.productId = to.query.productId
        query.referrerCod = to.query.referrerCod
        query.referrerType = to.query.referrerType
      } else if (to.query.sectionId && to.query.referrerCod && to.query.referrerType) {// 专享产品列表分享链接进入
        query.sectionId = to.query.sectionId
        query.referrerCod = to.query.referrerCod
        query.referrerType = to.query.referrerType
      }
      //用router push，如果用next({key:value})会导致报错
      //新版本的vue-router已经不建议用next跳转了
      //因为要严格保证next只会调用一次，这通常是错误的来源
      await router.push({
        name: "login",
        query: query
      });
    }
  }
});

function enterProductCustom(to, next) {
  if (to.query.productId && to.query.referrerCod && to.query.referrerType) {
    CustApi.customizedProductPreach(to.query.productId)
      .then((data) => {
        if (data) {
          if (data.showDetail) {
            //share showDetail
            router.push({
              name: "detail-productdesc",
              query: { productId: to.query.productId }
            })
          } else {
            router.push({
              name: "home"
            })
          }
        } else {
          router.push({
            name: "home"
          })
        }
      })
      .catch((e) => {
        next()
        console.log(e.msg || e.message)
      })
  } else if (to.query.sectionId && to.query.referrerCod && to.query.referrerType) {
    enterSectionProductPreach(to, next)
  } else {
    next();
  }
};

/**
 * 我的专享分享链接进入
 * @param {*} to 
 * @param {*} next 
 */
function enterSectionProductPreach(to, next) {
  if (to.query.sectionId && to.query.referrerCod && to.query.referrerType) {
    CustApi.sectionProductPreach(to.query.sectionId)
      .then((data) => {
        if (data) {
          if (data.showList) {
            //share showList
            router.push({
              name: "myexclusive-companydesc",
              query: {
                sectionId: to.query.sectionId
              }
            })
          } else {
            router.push({
              name: "home"
            })
          }
        } else {
          router.push({
            name: "home"
          })
        }
      })
      .catch((e) => {
        next()
        console.log(e.msg || e.message)
      })
  } else {
    next();
  }
};

// 监听浏览器关闭事件，上报页面轨迹信息
window.addEventListener('beforeunload', function (e) {
  let currentTime = Date.now();
  if (store.state.userInfo && store.state.userInfo.custAccount.custId) {
    if (parseInt((currentTime - enterTime) / 1000) > 0) {
      let params = {
        custId: store.state.userInfo.custAccount.custId,
        pageName: document.title,
        enterTime: moment(enterTime).format("YYYY-MM-DD HH:mm:ss"),
        stayTime: parseInt((currentTime - enterTime) / 1000),
      };
      // 使用同步请求确保数据能够被成功上报
      try {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/mq/track', false); // 同步请求，使用与 pageTrack 函数相同的接口
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(params));
      } catch (error) {
        console.log('页面追踪失败：' + error.message);
      }
    }
  }
});

// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

// 针对 push 方法
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  } else {
    return originalPush.call(this, location).catch((err) => err)
  }
}

// 针对 replace 方法
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

export { router, whiteList };
